import clsx from 'clsx';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

import { noopFunction } from '@vestico/utils';

import { Spinner, SpinnerPositioning, SpinnerSize } from '@vestico/shared';

import style from './LayoutLoadMoreHandler.module.css';

export interface LayoutLoadMoreHandlerProps {
  isItem?: boolean;
  loading?: boolean;
  loadMore?: () => void;
}

export const LayoutLoadMoreHandler = ({ isItem, loading, loadMore }: LayoutLoadMoreHandlerProps) => {
  const { ref, inView } = useInView();

  // We add a delayed loading variable to give time for the UI to disappear
  // Otherwise, we'll load more twice
  const [delayedLoading, setDelayedLoading] = useState(false);

  useLayoutEffect(() => {
    if (!loading) {
      const id = setTimeout(() => setDelayedLoading(!!loading), 300);
      return () => clearTimeout(id);
    }
    setDelayedLoading(loading);
    return noopFunction;
  }, [loading]);

  useEffect(() => {
    if (inView && !delayedLoading && loadMore) {
      loadMore();
    }
  }, [inView, loadMore, delayedLoading]);

  if (!loadMore) {
    return null;
  }

  return (
    <div className={clsx(style.root, { [style.item]: isItem })} ref={ref}>
      {inView ? (
        <div className={clsx(style.innerSpinner, { [style.visible]: loading })}>
          <Spinner size={SpinnerSize.medium} positioning={SpinnerPositioning.flex} />
        </div>
      ) : null}
    </div>
  );
};
